const pad = (value, places = 2, char = '0') => {
    return String(value).padStart(places, char)
}

export default pad